import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import { MediaKitConfigDto } from '../../common/general-types/media-kit.dto';

@Injectable({
  providedIn: 'root',
})
export class MediaKitService {
  private readonly httpService = inject(HttpService);

  getMediaKitConfigByCreatorId(creatorId: string): Observable<MediaKitConfigDto> {
    return this.httpService.runHttpCall(
      'GET',
      `/media-kit/config/${creatorId}`,
      'application/json',
    ) as Observable<MediaKitConfigDto>;
  }

  updateMediaKitConfig(
    mkConfigId: string,
    body: Partial<MediaKitConfigDto>,
  ): Observable<MediaKitConfigDto> {
    return this.httpService.runHttpCall(
      'PATCH',
      `/media-kit/config/${mkConfigId}`,
      'application/json',
      body,
    ) as Observable<MediaKitConfigDto>;
  }
}
